import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";

@Component({
  selector: "app-switch-btn",
  templateUrl: "./switch-btn.component.html",
  styleUrls: ["./switch-btn.component.scss"],
})
export class SwitchBtnComponent implements OnInit, OnDestroy {
  translationModulesEnum = TranslationModuleEnum;

  private endSub$ = new Subject();

  @Input() label: string;
  @Input() assignedLabelTranslationKey: string;
  @Input() assignedLabelTranslationModuleEnum: number;
  @Input() id: string = null;
  @Input() isRounded: boolean = true;
  private _value: any;
  @Input() isRequired:boolean = false;
  public get value(): any {
    return !!this._value ? JSON.parse(this._value) : this._value;
  }
  @Input() public set value(value: any) {
    this._value = !!value ? JSON.parse(value) : value;
  }
  @Output() onChange: EventEmitter<boolean> = new EventEmitter();

  //@Input() onlyForDestroyedChart: boolean = false;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.handleLanguageChange();
  }

  sendValue(e: any) {
    this.onChange.emit(e.currentTarget.checked);
  }

  //to handle chart

  handleLanguageChange() {
    // this.translate.onLangChange.pipe(takeUntil(this.endSub$)).subscribe(lang => {
    //   if (this.onlyForDestroyedChart) {
    //     let xx: any = document.querySelector('.checkboxx')
    //     xx.click()
    //     xx.click()
    //   }
    // })
  }

  ngOnDestroy(): void {
    this.endSub$.next(null);
    this.endSub$.complete();
  }
}
